import { useRoof } from '../../../../../../hooks/state/useRoof'
import { CachedMeshPhysicalMaterial } from '../../../../../material/cachedMeshPhysicalMaterial'

export const FrontGlassMaterial = () => {
  const { opacity, roughness } = useRoof()
  return (
    <CachedMeshPhysicalMaterial
      color={'lightgrey'}
      depthWrite={false}
      {...{
        envMapIntensity: 0.7,
        clearcoat: 1,
        reflectivity: 2,
        transparent: true,
        opacity: opacity,
        roughness: roughness,
      }}
    />
  )
}
